import { useRef, useState } from "react";
import axios from "axios";

import TreePages from "./components/TreePages";
import Button from "../../components/UI/Button";
import LottieLoaders from "../../components/UI/LottieLoaders";

import { scrollToCurrentStep } from "../../utils/scrollToCurrentStep";
import { config } from "../../config";

export const SelectedPagesStep = ({ nextStep, userData, setUserData }) => {
  const sectionRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedPages, setSelectedPages] = useState(0);

  const preparePayload = (userData) => ({
    urls: (userData.selectedPages || []).map((page) => ({
      url: page.url,
      title: page.title,
    })),
    id: userData.id,
  });

  const handleResponse = (response) => {
    if (response.data.errors) {
      setIsLoading(false);
    } else {
      setUserData((prevUserData) => ({
        ...prevUserData,
        AIResponse: [response.data.estimations],
        urls: response?.data?.urls || [],
        originalFiles: response?.data?.urls || [],
      }));
      setIsLoading(false);
      nextStep();
    }
  };

  const handleError = (error) => {
    console.error(error);
    setIsLoading(false);
  };

  const submit = async (userData) => {
    const payload = preparePayload(userData);

    scrollToCurrentStep(sectionRef);

    setIsLoading(true);

    try {
      const response = await axios.post(
        `${config.BASE_API_URL}/api/v1/clients/screenshot-analysis`,
        payload
      );
      handleResponse(response);
    } catch (error) {
      handleError(error);
    }
  };

  const isSubmitDisabled = !(
    userData.selectedPages && userData.selectedPages.length > 0
  );

  return (
    <div className="app-ai-quote-selected-pages" ref={sectionRef}>
      {isLoading ? (
        <LottieLoaders pageCount={selectedPages || 1} />
      ) : (
        <>
          <h4>
            Choose which pages you&apos;d like to include in the new site.
          </h4>
          <TreePages
            userData={userData}
            setUserData={setUserData}
            setSelectedPages={setSelectedPages}
          />
          <Button
            type="submit"
            onClick={() => submit(userData)}
            disabled={isSubmitDisabled}
          >
            Calculate Now
          </Button>
        </>
      )}
    </div>
  );
};
